import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

const About = () => {
  return (
    <>
    <Header />
    <section id="about" className="py-16 px-6 text-center">
      <h3 className="text-3xl font-semibold mb-6">About Us</h3>
      <p className="text-lg max-w-3xl mx-auto">
      PoemExtra is a vibrant platform dedicated to poetry enthusiasts of all kinds. Whether you are a budding poet seeking to share your unique voice or a passionate poetry lover eager to discover profound expressions, you’ll find a welcoming space here. This is a community where meaningful words and heartfelt emotions come together, allowing you to explore, share, and connect with the beauty of poetry in its many forms. Join us in celebrating the art of verse and the power of expression.
      </p>
    </section>
    <Footer />
    </>
  );
};

export default About;